import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { FormControlLabel, Checkbox } from '@mui/material';

const EngineScoringKnockoutCriteriaListSummaryComponent = ({ criterion, dictionaryKnockoutCriteria }) => {
  const { t } = useTranslation();
  const getCriterionName = () => {
    if (criterion.criteriaId) {
      let dictionaryName = dictionaryKnockoutCriteria.filter(x => x.id === criterion.criteriaId);
      return dictionaryName.length !== 0 ? dictionaryName[0].name : '';
    }
    return '';
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={5}>
        {t('EngineScoring.EngineScoringKnockoutCriteria.Criterion')} : <span> {getCriterionName()} </span>
      </Grid>
      <Grid item xs={12} sm={2}>
        {t('EngineScoring.EngineScoringKnockoutCriteria.ManualYN')} :{' '}
        <FormControlLabel control={<Checkbox checked={Boolean(criterion.manualYN)} disabled={true} />} />
      </Grid>
      <Grid item xs={12} sm={2}>
        {t('EngineScoring.EngineScoringKnockoutCriteria.PreScoring')} :{' '}
        <FormControlLabel control={<Checkbox checked={Boolean(criterion.preScoring)} disabled={true} />} />
      </Grid>
      <Grid item xs={12} sm={2}>
        {t('EngineScoring.EngineScoringKnockoutCriteria.PostScoring')} :{' '}
        <FormControlLabel control={<Checkbox checked={Boolean(criterion.postScoring)} disabled={true} />} />
      </Grid>
    </Grid>
  );
};

EngineScoringKnockoutCriteriaListSummaryComponent.propTypes = {
  criterion: PropTypes.object.isRequired,
  dictionaryKnockoutCriteria: PropTypes.array
};

export default EngineScoringKnockoutCriteriaListSummaryComponent;
